import { useCallback } from 'react';
import { prop } from 'ramda';
import { useGetDynamicBalances } from 'server';
import { useAppSelector } from 'js/store/hooks';
import { IGetDynamicBalancesResponseData } from 'js/hooks/socket/hooks/useGetDynamicBalances/types';

import { useUpdateUserBalance } from './useUpdateUserBalance';

export const useFetchBalance = () => {
    const updateUserBalance = useUpdateUserBalance();
    const getDynamicBalances = useGetDynamicBalances();
    const sessionSubscriptionBalances = useAppSelector(prop('sessionSubscriptionBalances'));

    return useCallback(async (options?: { signal?: AbortSignal }): Promise<{ data: IGetDynamicBalancesResponseData }> => {
        const subscriptionBalanceTypes = sessionSubscriptionBalances
            .split(',')
            .map(type => type.trim());

        const data = await getDynamicBalances({ balanceTypes: subscriptionBalanceTypes }, options);

        updateUserBalance(data.balances);

        return { data };
    }, [sessionSubscriptionBalances, getDynamicBalances, updateUserBalance]);
};
